import React, { ReactElement, ReactNode } from "react";
import { Box, Flex, FlexProps, HStack, forwardRef } from "@chakra-ui/react";
import { ColorModeSwitcher } from "./ColorModeSwitcher";
import { LogoTitle } from "./LogoTitle";
import { UserStatus } from "./UserStatus";

interface HeaderProps extends FlexProps {
  children?: ReactNode;
  withUserStatus?: boolean;
  hasBreadcrumb?: boolean;
  afterHeader?: ReactElement;
}

export const Header = forwardRef(
  (
    {
      children,
      withUserStatus = true,
      hasBreadcrumb = true,
      afterHeader,
      ...props
    }: HeaderProps,
    ref
  ) => (
    <Box pos="sticky" top="0" zIndex="docked">
      <Flex
        as="header"
        align="center"
        justifyContent="space-between"
        px="5"
        py="4"
        bg="bg"
        ref={ref}
        {...props}
      >
        {hasBreadcrumb ? (
          <LogoTitle hasBreadcrumb>{children}</LogoTitle>
        ) : (
          children
        )}
        <HStack ml="auto" minW="25%" w="fit-content" justifyContent="flex-end">
          <ColorModeSwitcher />
          {withUserStatus && <UserStatus />}
        </HStack>
      </Flex>
      {afterHeader}
    </Box>
  )
);
